import { LocalizationService } from 'services/LocalizationService'

export default class BitmapText extends PIXI.BitmapText {
  constructor(data) {
    super(LocalizationService.get(data.text), data.style)
    this._data = data
    const align = data.style.align
    const valign = data.style.valign
    const vRatio = valign == 'bottom' ? 1 : (valign == 'center' ? 0.5 : 0)
    const ratio = align == 'right' ? 1 : (align == 'center' ? 0.5 : 0)

    this.anchor.x = ratio
    this.x = data.width * ratio
    this.anchor.y = vRatio
    this.y = data.height * vRatio
    this.name = data.name
    this.letterSpacing = data.letterSpacing ? data.letterSpacing : 0
    this.renderText = false
    this.startLength = this.text.length
    this.checkSize()
    this.resize()
  }

  checkSize() {
    if (this.width > this._data.width && this.fontSize > 1) {
      this.resize()
    }
  }

  resize() {
    this.fontSize = this.fontSize * 0.75
    this.checkSize()
  }

  update(value) {
    this.text = value
    this.size = this._data.style.fontSize
    this.checkSize()

  }

  get data(){
    return this._data
  }
}
